<template>
  <el-dialog
    v-if="blurFlag"
    id="blurDialog"
    title=""
    :visible="blurFlag"
    :width="dialogWidth"
    center
    :show-close="false"
  >
    <!-- Title -->
    <div class="dialogTitle">
      <span v-if="blurOption === 'payment'">
        {{ $t('component.blur.title') }}
      </span>
      <span v-else>
        Global Coach Group
      </span>
    </div>

    <!-- Service Blur -->
    <BlurService v-if="blurOption === 'service'" />

    <!-- Payment Blur -->
    <BlurPayment v-else-if="blurOption === 'payment'" />

    <!-- TOS Blur -->
    <BlurTos v-else-if="blurOption === 'tos'" />
  </el-dialog>
</template>

<script>
import dialog from '@/mixins/dialog';
import BlurService from './content/BlurService.vue';
import BlurTos from './content/BlurTos.vue';
import BlurPayment from './content/BlurPayment.vue';

export default {
  name: 'BlurDialog',

  components: {
    BlurService,
    BlurTos,
    BlurPayment,
  },

  mixins: [
    dialog,
  ],

  props: {
    blurFlag: {
      type: Boolean,
      default: false,
    },

    blurOption: {
      type: String,
      default: 'service',
    },
  },
};
</script>

<style lang="scss" scoped>
  #blurDialog {
    .dialogTitle {
      color: #003865;
      font-size: 18px;
      font-weight: bold;
      padding-bottom: 15px;
    }
  }
</style>

<style lang="scss">
  #blurDialog {
    .el-dialog__header {
      padding: 0;
    }
  }
</style>
